import { column_components } from '@components-common/tables';
import { clone, curry, view } from 'ramda';
import { safeMerge } from '@components-common/utils';
import { TableComponent, TableProps } from '@components-common/types';
import { IRootieComponent } from '@components-common/types';
import { DeepPartial, Optional, RequiredKeys } from 'utility-types';
import { defaultProps } from './defaults';
import { stat } from 'fs';
import { RootieTable } from '../../../components-common/tables/RootieTable';

type R1 = Optional<IRootieComponent<Omit<TableProps, 'options'>>, 'Component'>;
type R2 = Partial<IRootieComponent<Omit<TableProps, 'options'>>>;

export const defaultTable: DeepPartial<TableComponent> = {
  key: 'table',
  Component: RootieTable as any,
  props: defaultProps,
};

export const defaultTableActions = [
  'download',
  'submitted',
  'copy',
  'edit',
  'delete',
  'view',
];
export const entityColumns = ['id', 'createdDate', 'modifiedDate'];
export const commonColumns = ['name', 'description', ...entityColumns];

const withDefaults = curry(safeMerge)(defaultProps);

export const table_viewer = {
  actions: ['view'],
};

export const table_editor = {
  //columns:entityColumns
};

export const table_common_viewer = {
  columns: commonColumns,
};

export const table_common_editor = {
  columns: commonColumns,
};

export const table_static = {
  columns: commonColumns,
};

export const table_common = {
  columns: commonColumns,
};

export const tablesModes = {
  editor: withDefaults({
    actions: ['edit', 'delete', 'copy'],
    ...table_editor,
  }),
  viewer: withDefaults({
    ...table_viewer,
  }),
  static: withDefaults({
    actions: [],
  }),
};

export const table_defaults = {
  default: defaultProps,
  view: withDefaults(table_viewer),
  edit: withDefaults(table_editor),
  index: withDefaults(table_editor),
  common: withDefaults(table_common),
  ...tablesModes,
};

export const column_defaults = column_components;
